import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Typography,
} from "@pankod/refine-mui";

import React, { useState } from "react";

import CustomDatePicker from "./DatePickerMUI";
import moment from "moment";

function StatisticsDateFilter({ start, setStart, end, setEnd }) {
  const [year, setYear] = useState("");
  const [month, setMonth] = useState("");

  const RELEASE_YEAR = 2023;

  const handleChangeYear = (e) => {
    setYear(e.target.value);
    setMonth(""); //reset month
    if (e.target.value) {
      //this is to prevent endDate to be after today
      var maxEnd =
        moment(`${e.target.value}-12-31`) < moment(new Date())
          ? moment(`${e.target.value}-12-31`)
          : moment(new Date());
      setStart(moment(`${e.target.value}-01-01`));
      setEnd(maxEnd);
    }
  };

  const handleChangeMonth = (e) => {
    const currentMonth = e.target.value;
    setMonth(currentMonth);
    const currentYear = year ? year : moment(new Date()).year();
    if (!year) setYear(moment(new Date()).year());
    if (currentMonth != undefined) {
      const firstDayOfMonth = moment({ year: currentYear, month: currentMonth })
        .startOf("month")
        .format("YYYY-MM-DD");
      const lastDayOfMonth = moment({ year: currentYear, month: currentMonth })
        .endOf("month")
        .format("YYYY-MM-DD");

      setStart(firstDayOfMonth);
      setEnd(lastDayOfMonth);
    }
  };

  const yearList = [];
  for (var i = RELEASE_YEAR; i <= moment(new Date()).year(); i++) {
    yearList.push(i);
  }

  const monthsInItalian = moment.months();

  return (
    <Grid container spacing={3}>
      <Grid item xs={6} md={3} sx={{ height: "100%" }}>
        <Stack direction={"row"} alignItems={"center"} spacing={1}>
          <Typography variant="h6" sx={{ fontWeight: 700 }}>
            Dal:
          </Typography>
          <CustomDatePicker
            label={"Seleziona data"}
            variant={"standard"}
            fullWidth={true}
            value={start}
            onChange={(e) => {
              setStart(e);
              setYear("");
              setMonth("");
            }}
            disableDay={(day) => {
              return day > moment(end) || day > moment(new Date());
            }}
          />
        </Stack>
      </Grid>
      <Grid item xs={6} md={3} sx={{ height: "100%" }}>
        <Stack direction={"row"} alignItems={"center"} spacing={1}>
          <Typography variant="h6" sx={{ fontWeight: 700 }}>
            Al:
          </Typography>
          <CustomDatePicker
            label={"Seleziona data"}
            variant={"standard"}
            fullWidth={true}
            value={end}
            onChange={(e) => {
              setEnd(e);
              setYear("");
              setMonth("");
            }}
            disableDay={(day) => {
              return day > moment(new Date()) || day < moment(start);
            }}
          />
        </Stack>
      </Grid>

      <Grid item xs={6} md={3} sx={{ height: "100%" }}>
        <FormControl fullWidth>
          <InputLabel id="year-label">Anno</InputLabel>
          <Select
            id="Anno"
            value={year}
            label="Anno"
            onChange={(e) => handleChangeYear(e)}
            fullWidth={true}
          >
            <MenuItem value={""}> </MenuItem>
            {yearList.map((year) => (
              <MenuItem key={year} value={year}>
                {year}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>

      <Grid item xs={6} md={3} sx={{ height: "100%" }}>
        <FormControl fullWidth>
          <InputLabel id="year-label">Mese</InputLabel>
          <Select
            id="Mese"
            value={month}
            label="Mese"
            onChange={(e) => handleChangeMonth(e)}
            fullWidth={true}
          >
            <MenuItem value={""}> </MenuItem>
            {monthsInItalian.map((m, index) => (
              <MenuItem key={m} value={index}>
                {m}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
    </Grid>
  );
}

export default StatisticsDateFilter;
